import React from "react";
import { Nav, NavSplit } from "./styles";
import ShipTo from "./ShipTo";
import Language from "./Language";
import { CountryInfo, CurrencyInfo } from "../../../../../headerServices/header/header";

// const getText = getLangKeyValueFun(langGroup);

export interface HeaderNavProps {
	/** not top, 全部国家/地区 */
	countries: CountryInfo[];
	/** top country */
	popularCounties: CountryInfo[];
	/** 用户当前国家/地区 */
	userCountry: CountryInfo;
	/** 全部货币 */
	currencies: CurrencyInfo[];
	/** 用户当前货币 */
	userCurrency: CurrencyInfo;
	/** 全部语言 */
	languages: any[];
	/** 用户当前语言 */
	userLanguage: any;
	onChangeLanguage?: (lan?: string) => void;
	/** 低价APP 30%折扣应用国家 */
	lowPriceCountryPriceOff: string;
}

class HeaderNav extends React.Component<HeaderNavProps> {
	render() {
		const {
			countries = [],
			userCountry,
			currencies = [],
			userCurrency,
			popularCounties = [],
			languages = [],
			userLanguage,
			onChangeLanguage,
		} = this.props;
		return (
			<Nav>
				<ShipTo
					countries={countries}
					popularCounties={popularCounties}
					userCountry={userCountry}
					currencies={currencies}
					userCurrency={userCurrency}
				/>
				<NavSplit style={{ marginRight: 18, marginLeft: 14 }} />
				<Language
					languages={languages}
					userLanguage={userLanguage}
					onChangeLanguage={onChangeLanguage}
				/>
			</Nav>
		);
	}
}

export default HeaderNav;
